import { GMetrixDateRangePicker } from 'components/GMetrixDateRangePicker';
import { useGMetrixTable } from 'components/GMetrixTable/context';
import { useIntl } from 'react-intl';

export type TableDateFilter = {
    disabled?: boolean;
    endDate: Date | null;
    maxDate?: Date | null;
    minDate?: Date | null;
    onChange: (startDate: Date | null, endDate: Date | null) => void;
    placeholder?: string;
    startDate: Date | null;
};

export const GMetrixTableDateFilter = () => {

    const { dateFilter } = useGMetrixTable();

    const { formatMessage } = useIntl();

    return dateFilter ? (
        <GMetrixDateRangePicker
            hideLabel
            disabled={dateFilter.disabled}
            endDate={dateFilter.endDate}
            maxDate={dateFilter.maxDate}
            minDate={dateFilter.minDate}
            onChange={dateFilter.onChange}
            placeholder={dateFilter.placeholder ?? formatMessage({ id: 'choose_dates.6a545adb', defaultMessage: 'Choose dates...' })}
            startDate={dateFilter.startDate}
        />
    ) : null;

};
